import { BREAKPOINT_MD } from '../globals.js';

export default class SlideIns {
	constructor() {
		this.scrollThreshold = window.innerHeight/2; // 50vh
		this.slideInsWrapper = null;
		this.slideInElements = [];
		this.isMobile = window.innerWidth < BREAKPOINT_MD; // md breakpoint
		this.findSlideInsWrapper();
		this.findSlideInElements();
		this.bindEvents();
		this.bindResize();
	}

	static init() {
		return new SlideIns();
	}

	findSlideInsWrapper() {
		// Find the slide-ins wrapper element
		this.slideInsWrapper = document.querySelector('.slide-ins');
	}

	findSlideInElements() {
		// Find all slide-in elements
		if (this.slideInsWrapper) {
			this.slideInElements = this.slideInsWrapper.querySelectorAll('.slide-in');
		}
	}

	bindEvents() {
		// Bind scroll event to check if user has scrolled 100vh
		window.addEventListener('scroll', () => {
			this.checkScrollPosition();
		});

		// Also check on page load in case user refreshes mid-scroll
		this.checkScrollPosition();

		// Bind hover and click events for slide-in elements
		this.bindSlideInEvents();
	}

	bindResize() {
		// Update mobile detection on resize
		window.addEventListener('resize', () => {
			this.isMobile = window.innerWidth < BREAKPOINT_MD;
		});
	}

	bindSlideInEvents() {
		this.slideInElements.forEach((slideIn, index) => {
			const link = slideIn.querySelector('.slide-in-link');
			const href = link ? link.getAttribute('href') : null;
			const target = link ? link.getAttribute('target') : null;
			
			// Track if this slide-in is currently expanded (for mobile)
			slideIn._isExpanded = false;

			if (this.isMobile) {
				// Mobile: First click expands, second click opens link
				slideIn.addEventListener('click', (e) => {
					e.preventDefault();
					
					if (!slideIn._isExpanded) {
						// First click: expand the slide-in
						slideIn._isExpanded = true;
						slideIn.classList.add('expanded');
					} else {
						// Second click: open the link respecting target attribute
						if (href) {
							if (target === '_blank') {
								window.open(href, '_blank');
							} else if (target === '_self' || !target) {
								window.location.href = href;
							} else {
								window.open(href, target);
							}
						}
					}
				});

				// Reset expanded state when clicking outside
				document.addEventListener('click', (e) => {
					if (!slideIn.contains(e.target) && slideIn._isExpanded) {
						slideIn._isExpanded = false;
						slideIn.classList.remove('expanded');
					}
				});
			} else {
				// Desktop: Hover expands, click opens link
				slideIn.addEventListener('click', (e) => {
					if (href) {
						e.preventDefault();
						
						if (target === '_blank') {
							window.open(href, '_blank');
						} else if (target === '_self' || !target) {
							window.location.href = href;
						} else {
							window.open(href, target);
						}
					}
				});
			}
		});
	}

	checkScrollPosition() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		
		// Check if user has scrolled through 100vh
		if (scrollTop >= this.scrollThreshold) {
			this.activateSlideIns();
		} else {
			// Deactivate when scroll is less than 100vh
			this.deactivateSlideIns();
		}
	}

	activateSlideIns() {
		if (this.slideInsWrapper) {
			// Add the 'active' class to trigger CSS animations
			this.slideInsWrapper.classList.add('active');
		}
	}

	deactivateSlideIns() {
		if (this.slideInsWrapper) {
			// Remove the 'active' class to hide CSS animations
			this.slideInsWrapper.classList.remove('active');
		}
	}

	// Method to reset trigger (useful for testing or dynamic content)
	reset() {
		this.deactivateSlideIns();
	}

	// Method to manually trigger slide-ins
	manualTrigger() {
		if (!this.triggered) {
			this.triggered = true;
			this.activateSlideIns();
		}
	}
}